<div class="flex flex-col">
  <app-section-header [title]="'Content Lists'">
    <button
      mat-flat-button
      color="primary"
      [routerLink]="['create']"
      [queryParams]="getQueryParams(websitesFilter.value)"
      class="ml-3"
    >
      <mat-icon>add</mat-icon>
      Create New
    </button>
  </app-section-header>

  <div class="flex items-center justify-end content-stretch">
    <div *ngIf="hasFiltersSet()" class="pr-3">
      <button
        mat-button
        color="secondary"
        (click)="resetFilters()"
        matTooltip="Reset filters back to their default values"
      >
        <mat-icon>clear</mat-icon>
        Reset Filters
      </button>
    </div>
    <mat-form-field
      [floatLabel]="'never'"
      appearance="outline"
      class="w-1/4 content-list_search-box"
    >
      <input
        [(ngModel)]="searchContentListvalue"
        matInput
        (keyup)="applyFilter($event.target.value)"
        placeholder="Search content list ... "
      />
      <mat-icon *ngIf="!searchContentListvalue" matSuffix class="ml-2"
        >search</mat-icon
      >
      <button
        mat-button
        *ngIf="searchContentListvalue"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchContentListvalue = ''; applyFilter('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div
    class="w-full max-w-full font-sans mat-elevation-z0 content-lists__table"
  >
    <div
      class="relative w-full min-w-full font-sans mat-elevation-z0 content__table"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="w-full max-w-full font-sans content-lists__table"
        matSortActive="lastModifiedDateTime"
        matSortDirection="desc"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let contentList" class="py-3">
            <a color="primary" [routerLink]="['./', contentList.id]"
              >{{ contentList.name }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="website">
          <th mat-header-cell *matHeaderCellDef>
            <mat-form-field [floatLabel]="'never'" appearance="outline">
              <mat-label>Website</mat-label>
              <mat-select
                matNativeControl
                multiple
                [formControl]="websitesFilter"
              >
                <mat-select-trigger>
                  {{ websitesFilter.value ? websitesFilter.value[0] : "" }}
                  <span *ngIf="websitesFilter.value?.length > 1">
                    (+{{ websitesFilter.value.length - 1 }}
                    {{
                      websitesFilter.value.length === 2 ? "other" : "others"
                    }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let website of websiteList"
                  [value]="website"
                  >{{ website }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let contentList" class="py-3">
            <p *ngFor="let website of contentList.website">{{ website }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="contentListType">
          <th mat-header-cell *matHeaderCellDef>
            <mat-form-field [floatLabel]="'never'" appearance="outline">
              <mat-label>Type</mat-label>
              <mat-select
                matNativeControl
                multiple
                [formControl]="contentListTypeFilter"
              >
                <mat-select-trigger>
                  {{
                    (contentListTypeFilter.value
                      ? contentListTypeFilter.value[0]
                      : ""
                    ) | camelCaseSplit
                  }}
                  <span *ngIf="contentListTypeFilter.value?.length > 1">
                    (+{{ contentListTypeFilter.value.length - 1 }}
                    {{
                      contentListTypeFilter.value.length === 2
                        ? "other"
                        : "others"
                    }})
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngFor="let contentListType of contentListTypeList"
                  [value]="contentListType"
                >
                  {{ contentListType | camelCaseSplit }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let contentList" class="py-3">
            {{ contentList.contentListType | camelCaseSplit }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastModifiedDateTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <mat-form-field [floatLabel]="'never'" appearance="outline">
              <mat-label>Modified</mat-label>
              <mat-select
                matNativeControl
                [formControl]="modifiedFilter"
                disableOptionCentering
              >
                <mat-option
                  *ngFor="let time of modifiedTimeSelectionList"
                  [value]="time.id"
                  >{{ time.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let contentList" class="py-3">
            <mat-icon inline class="px-1">access_time</mat-icon>
            <span>{{ contentList.lastModifiedDateTime | formatdate }}</span>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="px-4 py-3 border-t bg-project-600 border-t-project-700"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <app-processing-boundary
        *ngIf="isProcessing || !dataSource?.filteredData.length"
        class="flex h-full"
        [ngClass]="{
          'min-h-[20vh]': !dataSource?.filteredData.length
        }"
        [isProcessing]="isProcessing"
        [showEmptyResultMsg]="!dataSource?.filteredData.length"
        [processingMsg]="'Loading content...'"
        [cssClasses]="[
          'absolute',
          'top-[4.3rem]',
          'w-full',
          'h-full',
          'backdrop-contrast-50'
        ]"
      >
      </app-processing-boundary>
      <div
        class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
        *ngIf="dataSource?.filteredData?.length"
      >
        <div>
          <!-- TODO PROTRACTOR: Leaving content-lists__page-button so protractor test dont break -->
          <button
            class="content-lists__page-button bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100"
            (click)="loadContentLists()"
            title="Refresh"
          >
            <i class="icon icon-refresh"></i>
          </button>
          <mat-form-field
            [floatLabel]="'never'"
            class="w-16 text-sm leading-[0.99rem] content-lists__page-select"
            appearance="outline"
          >
            <mat-select [formControl]="pageSizeFilter">
              <mat-option *ngFor="let page of pagingOptions" [value]="page">
                {{ page }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="pl-3">per page</span>
        </div>
        <div>
          <button
            class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
            [disabled]="!dataSource?.paginator?.hasPreviousPage()"
            (click)="cmsPaginationService.previousPage(dataSource)"
          >
            Previous
          </button>
          <button
            *ngFor="let num of cmsPaginationService.pageNumbers"
            class="content-lists__page-button bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
            (click)="cmsPaginationService.selectPage(dataSource, num)"
            [disabled]="cmsPaginationService.isActivePage(dataSource, num)"
            [ngClass]="{
              'content-lists__page-button--current':
                cmsPaginationService.isActivePage(dataSource, num)
            }"
          >
            {{ num }}
          </button>
          <button
            class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
            (click)="cmsPaginationService.nextPage(dataSource)"
            [disabled]="!dataSource?.paginator?.hasNextPage()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    class="invisible"
  ></mat-paginator>
</div>
